import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'jobs',
});

export const jobsDetailRouteRef = createSubRouteRef({
  id: 'jobs-detail',
  parent: rootRouteRef,
  path: '/:jobId',
});
